
import { computed, defineComponent, ref } from 'vue';
import FormInput from './FormInput.vue';
import { required, length, Status, validate } from '../validation';
import { User, useStore } from '../store';
import { useModal } from '@/useModal';

export default defineComponent({
  name: 'App',
  components: { FormInput },
  setup() {
    const username = ref('username');

    const usernameSatus = computed<Status>(() => {
      return validate(username.value, [
        required(),
        length({ min: 5, max: 10 }),
      ]);
    });

    const password = ref('password');

    const passwordStatus = computed<Status>(() => {
      return validate(password.value, [
        required(),
        length({ min: 10, max: 20 }),
      ]);
    });

    const store = useStore();
    const modal = useModal();

    const submit = async (evt: Event) => {
      if (!usernameSatus.value.valid || !passwordStatus.value.valid) {
        return;
      }
      const newUser: User = {
        id: '-1',
        username: username.value,
        password: password.value,
      };
      await store.createUser(newUser);
      modal.hideModal();
    };

    return {
      passwordStatus,
      usernameSatus,
      username,
      password,
      submit,
    };
  },
});
